export default {"src":"/_next/static/media/wrench.3c714a69.svg","height":42,"width":42};